import { render } from "./ShareSection.vue?vue&type=template&id=71c4dad1&scoped=true"
import script from "./ShareSection.vue?vue&type=script&lang=ts"
export * from "./ShareSection.vue?vue&type=script&lang=ts"

import "./ShareSection.vue?vue&type=style&index=0&id=71c4dad1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-71c4dad1"

export default script